// extracted by mini-css-extract-plugin
export var active = "Nav-module--active--XFRt0";
export var fullName = "Nav-module--full-name--N3oSu";
export var menu = "Nav-module--menu--tTdbl";
export var root = "Nav-module--root--C8HyW";
export var siteName = "Nav-module--site-name--o28ZQ";